
import { defineComponent, watch, ref, reactive } from 'vue';
import {
    vLoading,
    ElPagination,
    ElInput,
    ElAlert,
    ElMessage,
} from 'element-plus';

import { UserTag, StyleInput } from '@/components/common';

import GenreHead from '@/widgets/GenreHead.vue';
import { GeneresNav } from '@/components/Genres';
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { createArticleDraft, doLockGenre, genreInfo, getAlbums, getGenreArticles, getRankInfo, sendGenreCounterView, doEditGenre } from '@/services';
import { AlbumModel, ArticleModel, ArtistModel, GenreStyleModel, RankModel } from '@/typings';
import RankItem from '@/components/ArticleListItem/Rank.vue';
import ArticleListItem from '@/components/ArticleListItem';

import { AlbumItem as GenreInfoAlbum, ArtistItem as GenreInfoArtist } from '@/components/EntityListItem';
import { useUserInfo } from '@/store';

import CreateRank from '@/widgets/CreateRank.vue';
import wx from '@/basics/wx';
import ajax from '@/basics/fetch';
import wechatTitle from '@/directives/wechat-title';
import GenreEdit from "@/components/Editor/GenreEdit.vue";

export default defineComponent({
    directives: {
        vLoading,
        wechatTitle
    },
    components: {
        GeneresNav,
        GenreHead,
        UserTag,
        RankItem,
        ArticleListItem,
        ElPagination,
        ElInput,
        GenreInfoAlbum,
        GenreInfoArtist,
        ElAlert,
        GenreEdit,
        CreateRank
    },
    setup () {
        const route = useRoute();
        const router = useRouter();
        const userInfo = useUserInfo();

        const info = ref<GenreStyleModel | null>(null);
        const childs = ref<GenreStyleModel[]>([]);
        const artists = ref<ArtistModel[]>([]);

        const paginationAlbum = reactive({
            pageNow: 1,
            total: 0
        });

        const filterAlbum = reactive({
            beginYear: '0',
            endYear: '0'
        });
        const album_loading = ref(false);
        const albums = ref<AlbumModel[]>([]);
        const refreshAlbumData = () => {
            album_loading.value = true;
            getAlbums({
                page: paginationAlbum.pageNow,
                genre: info.value!._id,
                filter: filterAlbum,
                sort: 'hot'
            }).then((json) => {
                paginationAlbum.total = json.data.pages.total;
                albums.value = json.data.albums;
            }).finally(() => {
                album_loading.value = false;
            });
        };
        const handleAlbumPageChange = (page:number) => {
            paginationAlbum.pageNow = page;
            refreshAlbumData();
        };
        watch(() => {
            return {
                ...filterAlbum
            };
        }, refreshAlbumData);

        const albums_new = ref<AlbumModel[]>([]);
        const refreshAlbumNewData = () => {
            album_loading.value = true;
            getAlbums({
                page: 0,
                genre: info.value!._id,
                filter: {
                    rating_anon: 1
                },
                sort: 'year'
            }).then((json) => {
                albums_new.value = json.data.albums;
            }).finally(() => {
                album_loading.value = false;
            });
        };

        const paginationRank = reactive({
            pageNow: 1,
            total: 0
        });
        const rank_loading = ref(false);
        const ranks = ref<RankModel[]>();
        const refreshRankData = () => {
            rank_loading.value = true;
            getRankInfo(info.value!._id, {
                page: paginationRank.pageNow
            }).then((json) => {
                ranks.value = json.data.ranks;
                paginationRank.total = json.data.pages.total;
            }).finally(() => {
                rank_loading.value = false;
            });
        };
        const handleRankPageChange = (page:number) => {
            paginationRank.pageNow = page;
            refreshRankData();
        };

        const rocknut_loading = ref(false);
        const paginationRocknut = reactive({
            pageNow: 1,
            total: 0
        });
        const articles = ref<ArticleModel[]>([]);
        const refreshRocknutData = () => {
            rocknut_loading.value = true;
            getGenreArticles(info.value!._id, {
                page: paginationRocknut.pageNow
            }).then((json) => {
                paginationRocknut.total = json.data.pages.total;
                articles.value = json.data.articles;
            }).finally(() => {
                rocknut_loading.value = false;
            });
        };
        const handleRocknutPageChange = (page:number) => {
            paginationRocknut.pageNow = page;
            refreshRocknutData();
        };

        const loading = ref(false);
        const handlerTimeout = ref(0);
        const refreshData = () => {
            if (!route.params.name_link) {
                console.log(666);
                return;
            }

            loading.value = true;

            genreInfo(route.params.name_link as string).then((json) => {
                loading.value = false;
                info.value = json.data.info;
                childs.value = json.data.childs;
                artists.value = json.data.artists;
                wx.wxConfig(ajax, {
                    title: info.value.name || info.value.name_orig,
                    desc: info.value.profile.substring(0, 30),
                    imgUrl: info.value.primary_img
                });
                refreshAlbumData();
                refreshAlbumNewData();
                refreshRankData();
                refreshRocknutData();

                handlerTimeout.value = window.setTimeout(() => {
                    sendGenreCounterView(info.value!._id);
                }, 5000);
            });
        };

        const clearTimeout = () => {
            handlerTimeout.value && window.clearTimeout(handlerTimeout.value);
        };

        onBeforeRouteUpdate(clearTimeout);
        onBeforeRouteLeave(clearTimeout);

        watch(() => {
            return route.params;
        }, refreshData, {
            immediate: true
        });

        const handlerCreateArticle = () => {
            if (info.value!.quality.index === 0) {
                ElMessage.error('请先协助完善信息');
                return;
            }

            createArticleDraft({
                reference_id: info.value!._id,
                type: 'genrehis'
            }).then((json) => {
                router.push({
                    path:
                        '/article/write/genrehis/' + info.value!._id + '/' + json.data.article_id
                });
            }).catch((json) => {
                ElMessage.error(json.data.msg);
            });
        };

        const handlerCreateCronicles = () => {
            if (info.value!.quality.index === 0) {
                ElMessage.error('请先协助完善信息');
                return;
            }

            createArticleDraft({
                type: 'chronicles',
                reference_id: info.value!._id
            }).then((json) => {
                router.push({
                    path: '/article/write/chronicles/' + info.value!._id + '/' + json.data.article_id
                });
            }).catch((json) => {
                ElMessage.error(json.data.msg);
            });
        };

        const createRankShow = ref(false);
        const handlerShowCreateRank = () => {
            createRankShow.value = !createRankShow.value;
        };

        const doLockInfo = () => {
            loading.value = true;
            doLockGenre(info.value!._id).then((json) => {
                info.value = {
                    ...info.value,
                    ...json.data.info
                };
            }).catch((json) => {
                ElMessage.error(json.data.msg);
            }).finally(() => {
                loading.value = false;
            });
        };

        const dialogFormEditVisible = ref(false);

        const showEditer = () => {
            if (!info.value) {
                return;
            }

            dialogFormEditVisible.value = true;
        };

        return {
            loading,
            info,
            childs,
            artists,

            albums,
            album_loading,
            filterAlbum,
            paginationAlbum,
            handleAlbumPageChange,

            ranks,
            rank_loading,
            paginationRank,
            handleRankPageChange,

            articles,
            rocknut_loading,
            paginationRocknut,
            handleRocknutPageChange,
            userInfo,
            handlerCreateArticle,
            handlerCreateCronicles,
            handlerShowCreateRank,
            createRankShow,

            doLockInfo,
            dialogFormEditVisible,
            showEditer,
            albums_new
        };
    }
});

